import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { catalogBibShape, bibShape } from '@bibliocommons/bc-prop-types';
import { getBibEntities, getCatalogBibEntities } from 'app/selectors/EntitiesSelector';
import UniversalBibBrief from './UniversalBibBrief';

export function UniversalBibBriefContainer(props) {
  return <UniversalBibBrief {...props} />;
}

UniversalBibBriefContainer.propTypes = {
  // ownProps
  metadataId: PropTypes.string.isRequired,
  // Redux props
  bib: bibShape.isRequired,
  catalogBib: catalogBibShape
};

const mapStateToProps = (state, ownProps) => ({
  bib: getBibEntities(state).get(ownProps.metadataId),
  catalogBib: getCatalogBibEntities(state).get(ownProps.metadataId)
});

export default connect(mapStateToProps)(UniversalBibBriefContainer);
